import React from 'react';
import {
  Box, Modal, IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './banner.css';
import { SIGNUP_URL } from '../../constants/ApiConstants';

type BannerProps = {
  subtitle?: string;
  backgroundImage: string;
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function Banner({ subtitle, backgroundImage }: BannerProps) {
  const [open, setOpen] = React.useState(false);
  const backgroundImagec1 = '/assets/images/IMG_3227.jpg';

  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div className="container-fluid banner-bg">
      {/* <div className="row">
        <div className="col-12 text-center p-0">
          <div className="marquee-container">
            <p className="marquee-content mb-0 fw-bold">No Holy Mass through Thursday (05/14/2026). Holy Mass resumes on Friday.</p>
          </div>
        </div>
      </div> */}
      <div className="row justify-content-center align-items-center">
        <div className="col-12 col-md-3">
          <div className="banner-content text-center text-md-start">
            <p>We welcome you to</p>
            <h1>Holy Family</h1>
            <h1>Syro-Malabar</h1>
            <h1>Catholic Church</h1>
            <h1>Halifax</h1>
            <a href={SIGNUP_URL} className="btn btn-primary btn-hfx mt-3 p-2">Join our community</a>
            {subtitle && <p>{subtitle}</p>}
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="banner-image" style={{ backgroundImage: `url(${backgroundImage})` }} />
        </div>
        <Modal open={open} onClose={handleClose}>
          <Box sx={style}>
            <div>
              <IconButton
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  color: 'grey.500',
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div
              className="xmas"
              style={{
                backgroundImage: `url(${backgroundImagec1})`,
                height: '470px',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                marginTop: '40px',
                backgroundPositionX: 'center',
              }}
            />
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default Banner;
